import { createFileRoute } from '@tanstack/react-router'
import AboutPage from '#/pages/AboutPage'
import { teachersQueryOptions } from '#/features/teachers/hooks/useTeachers'
import { testimonialsQueryOptions } from '#/features/home/hooks/useTestimonials'
import { coursesQueryOptions } from '#/features/courses/hooks/useCourses'

export const Route = createFileRoute('/_home/about')({
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(teachersQueryOptions({ limit: 8 })),
      queryClient.ensureQueryData(testimonialsQueryOptions()),
      queryClient.ensureQueryData(coursesQueryOptions({ limit: 5 })),
    ])
  },
  head: () => ({
    meta: [
      {
        title: "About Us | Wa'allamah",
      },
      {
        name: 'description',
        content:
          "Learn about Wa'allamah Institute, our mission, certified Quran instructors, and authentic online Islamic learning programs.",
      },
    ],
  }),
  component: AboutPage,
})
